import type { SessionConfig } from '@xing-com/crate-xinglet/internal';

import type { ConfigureRequest } from '../types';

export function configureRequestWithAcceptLanguageHeader({
  language,
}: SessionConfig): ConfigureRequest {
  return (request) => {
    request.headers.set('Accept-Language', language);

    return request;
  };
}
